import { useNavigate, useParams } from "react-router-dom";
import { usePageLoadMetric } from "../hooks/usePageLoadMetric";
import SupportForm from "../components/SupportForm";

/**
 * 応援設定ページ
 */
const SupportFormPage = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    usePageLoadMetric("support-form", true);

    const handleBack = () => {
        navigate(id ? `/employee/info/${id}/work-rules` : "/employee/info/new/work-rules");
    };

    const handleCancel = () => {
        navigate("/employee/info");
    };

    const handleNext = () => {
        navigate(id ? `/employee/info/${id}/tags` : "/employee/info/new/tags");
    };

    return (
        <SupportForm
            onBack={handleBack}
            onCancel={handleCancel}
            onNext={handleNext}
        />
    );
};

export default SupportFormPage;
